// extracted by mini-css-extract-plugin
export default {"social":"bottom_social__LvW2Q","icon":"bottom_icon__ZYdim","btnBackground":"bottom_btnBackground__oM4m4"};